import { usePrevious } from '@sequencehq/utils'
import { dequal } from 'dequal'
import { useEffect, useState } from 'react'

// Like `useState` but when the `currentValue` changes, the state is updated to match it.
export const useLiveState = <T>(currentValue: T, shouldUpdate = true) => {
  const hook = useState<T>(currentValue)
  const [, setState] = hook
  const previousValue = usePrevious(currentValue)

  useEffect(() => {
    if (shouldUpdate && !dequal(currentValue, previousValue)) {
      setState(currentValue)
    }
  }, [currentValue, previousValue, setState, shouldUpdate])

  return hook
}
